<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_acc_item_type_additional_item.add_title')">
    <template #content>
      <v-container fluid class="add-additional-item">
        <v-form ref="form">
          <v-text-field outlined
                        :label="$t('admin_acc_item_type_additional_item.name_en')"
                        v-model="additionalItem.name_en"
                        :rules="requiredRules"></v-text-field>
          <v-text-field outlined
                        :label="$t('admin_acc_item_type_additional_item.name_zh')"
                        v-model="additionalItem.name_zh"
                        :rules="requiredRules"></v-text-field>
          <v-text-field outlined
                        type="number"
                        min="0"
                        :label="$t('admin_acc_item_type_additional_item.price')"
                        v-model="additionalItem.price"
                        :rules="requiredRules"></v-text-field>
          <v-text-field outlined
                        type="number"
                        :label="$t('admin_acc_item_type_additional_item.max_per_booking')"
                        v-model="additionalItem.max_per_booking"
                        :rules="requiredRules"></v-text-field>
          <v-input hide-details="auto"
                   v-model="icon"
                   :rules="requiredRules">
            <v-container fluid class="flex-column">
              <legend class="v-label theme--light">{{ $t('admin_acc_item_type_additional_item.icon') }}</legend>
              <PhotoPreviewInput v-model="icon"
                                 file-name="item-type-icon"></PhotoPreviewInput>
              <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG</small>
            </v-container>
          </v-input>
        </v-form>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.form.validate() && save()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";

export default {
  name: 'AddItemTypeAdditionalItemModal',
  components: {PhotoPreviewInput, BGModal},
  props: {
    shown: Boolean,
    itemTypeId: String,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          additionalItem.value = {};
          icon.value = null;
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    //
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const additionalItem = ref({});
    const icon = ref(null);

    const save = async function () {
      root.$callAPI('room/admin/item_type/additional_item/set/', {
        item_type_id: props.itemTypeId,
        ...additionalItem.value,
        icon: await root.$convertFileToBase64(icon.value),
      }, (response) => {
        emit('cancel');
      });
    }


    return {
      dialogShown,
      cancel,

      requiredRules,
      additionalItem,
      icon,

      save,
    }
  },
}
</script>
